<template>
	<div class="user-menu" v-if="user">
		<router-link :to="{name: 'settings'}" class="user-menu__main">
			<div class="user-menu__main-row">
				<span class="user-menu__name">{{ user.username }}</span>
				<span v-if="user.rang" class="user-menu__rang" >{{ user.rang.title }}</span>
			</div>
			<div class="user-menu__balance" v-if="hideBalance">******</div>
			<div class="user-menu__balance" v-else id="userBalance" :mybalance="user.balance.toFixed(2)">{{ user.balance.toFixed(2) }}</div>
		</router-link>
		<div class="user-menu__wallet" @click="openWallet = !openWallet">
			<svg class="user-menu__wallet-icon"><use href="#svg-icon-wallet"></use></svg>
		</div>

	</div>

	<teleport to="body">
		<Modal class="user-menu__modal" :openState="openWallet"  @close="() => openWallet = false" :data="{title: 'Кошелёк'}">
			<div class="user-menu__tabs">
				<div class="tabs">
					<div class="tabs__item" :class="{active: activeTab === 'replenishment'}" @click="activeTab = 'replenishment'">Пополнение</div>
					<div class="tabs__item" :class="{active: activeTab === 'withdraw'}" @click="activeTab = 'withdraw'">Вывод</div>
				</div>
			</div>
			<div class="user-menu__body no-scrollbar" ref="body">
				<Deposit v-show="user !== null && activeTab === 'replenishment'" />
				<withdraw v-show="user !== null && activeTab === 'withdraw'" />
			</div>
		</Modal>
	</teleport>

	<div class="user-menu__buttons" v-if="user">
		<button type="button" class="btn user-menu__button btn--block btn--white" @click="() => {activeTab = 'replenishment';openWallet = true}"> Пополнить </button>
		<button type="button" class="btn user-menu__button btn--block" @click="() => {activeTab = 'withdraw';openWallet = true}"> Вывести </button>
	</div>
</template>

<script>

import { mapState } from 'pinia'
import { useUserStore } from '../../stores/User'
import scrollLock from 'scroll-lock';
import Deposit from "./Deposit.vue";
import Withdraw from "../../pages/withdraw/Withdraw.vue";
import Modal from "../blocks/Modal.vue";

export default {

	components: {
		Modal,
		Withdraw,
		Deposit
	},

	props: ['page'],

	data() {
		return {
			openWallet: false,
			activeTab: 'replenishment'
		}
	},

	watch: {
		openWallet(state) {
			state ? scrollLock.disablePageScroll(this.$refs.body) : scrollLock.enablePageScroll();
		}
	},

	mounted() {
		this.$root.emitter.on('openWallet', this.handlerOpenWallet);
	},

	unmounted() {
		this.$root.emitter.off('openWallet', this.handlerOpenWallet);
	},

	computed: {
		...mapState(useUserStore, ['user']),

		hideBalance() {
			return ['slotsGame'].includes(this.$route.name);
		},
	},

	methods: {
		handlerOpenWallet() {
			this.openWallet = true
		}
	}
}
</script>
